import { ReactSelectDropdownOption } from "@pepdirect/ui/dropdown/types";

export const getStartedFields = {
  firstName: {
    label: "First name",
    name: "firstName",
    autoComplete: "given-name",
  },
  lastName: {
    label: "Last name",
    name: "lastName",
    autoComplete: "family-name",
  },
  email: {
    label: "Email",
    name: "emailField",
    autoComplete: "email",
  },
  businessName: {
    label: "Business name",
    name: "businessName",
  },
  phone: {
    label: "Business phone number",
    name: "phoneNumber",
  },
  street: {
    label: "Business street address (US only)",
    name: "businessAddress",
  },
  city: {
    label: "City",
    name: "city",
  },
  state: {
    label: "State",
    name: "state",
  },
  zip: {
    label: "Zip",
    name: "zip",
  },
  type: {
    label: "Business setting",
    name: "businessType",
  },
  numUsers: {
    label: "Number of users",
    name: "numberOfUsers",
  },
  manageAndOrder: {
    label: "Who manages and orders your beverages?",
    name: "manageAndOrder",
  },
  isExistingCustomer: {
    label: "I am an existing PepsiCo customer",
    name: "existingCustomer",
  },
};

export const businessTypeOptions: ReactSelectDropdownOption[] = [
  { value: "Office", label: "Office" },
  { value: "Warehouse", label: "Warehouse" },
  { value: "School / University", label: "School / University" },
  { value: "Hotel / Hospitality", label: "Hotel / Hospitality" },
  { value: "Retail / Convenience", label: "Retail / Convenience" },
  { value: "Gym / Recreation", label: "Gym / Recreation" },
  { value: "Airport / Lounge", label: "Airport / Lounge" },
  { value: "Event Space ", label: "Event Space " },
  { value: "Other", label: "Other" },
];

export const numberOfUsersOptions: ReactSelectDropdownOption[] = [
  { value: "1-100", label: "1-100" },
  { value: "101-250", label: "101-250" },
  { value: "251-500", label: "251-500" },
  { value: "500+", label: "500+" },
];

export const manageAndOrderOptions: ReactSelectDropdownOption[] = [
  { value: "Office Manager", label: "Office Manager" },
  { value: "Food and Beverage Manager", label: "Food and Beverage Manager" },
  { value: "Third Party Operator", label: "Third Party Operator" },
  { value: "Other", label: "Other" },
];
